require('waypoints/lib/jquery.waypoints.min');

$('a[rel="external"]').attr('target', '_blank');

$('.animate-on-scroll').each(function () {
  $(this).addClass('pending-animation');
});


$('.animate-on-scroll').waypoint({
  handler: function (direction) {
    $(this.element).addClass("animate-initiate");
  },
  offset: '97%'
});

function leftNav() {
  var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
  var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
  var d = $(document).scrollTop();

  $(".dropdown-menu").each(function () {
    p = $(this).offset();

    //horizontal
    if ((p.left + $(this).width()) > $(window).innerWidth()) {
      $(this).addClass('menu-left');
    }
  });
}

$(document).ready(function () {

  $('.nav-toggle').on('click', function () {
    if ($('body').hasClass('js-nav-open')) {
      $('body').removeClass('js-nav-open');
    } else {
      $('body').addClass('js-nav-open');
    }
  });

  $('.nav-shop > .panel-toggle').on('click', function () {
    $this = $(this);
    $toggleRegion = $this.next('.toggle-region');

    if ($this.hasClass('open')) {
      $this.removeClass('open');
      $toggleRegion.removeClass('toggle-open');
    } else {
      $this.addClass('open');
      $toggleRegion.addClass('toggle-open');
    }
  });

  $('.site-overlay').on('click', function () {
    $('body').removeClass('js-nav-open');
  });

  $('.nav-arrow').on('click', function () {
    $this = $(this);
    $parent = $this.parent('span');

    $parent.toggleClass('dropdown-menu-open');

    if (!$parent.hasClass('dropdown-menu-open')) {
      $parent.next().stop().slideUp();
    } else {
      $parent.next().stop().slideDown();
    }
  });

  $('.nav-primary a').on('focus', function () {
    $(this).parents('li').addClass('focussed');
  }).on('blur', function () {
    $(this).parents('li').removeClass('focussed');
  });

  leftNav();
});

$(window).on('resize', function () {
  $('.dropdown-menu').removeClass('menu-left');
  leftNav();
});

$(window).scroll(function () {
  var $scroll = $(window).scrollTop();
  var $offset = ($(".header-primary").height() + 150);

  if ($scroll >= $offset) {
    $(".header-primary").addClass("js-header-small");
  } else {
    $(".header-primary").removeClass("js-header-small");
  }
});

(function () {

  var youtube = document.querySelectorAll(".youtube");

  for (var i = 0; i < youtube.length; i++) {

    var source = "https://img.youtube.com/vi/" + youtube[i].dataset.embed + "/sddefault.jpg";

    var image = new Image();
    image.src = source;
    image.addEventListener("load", function () {
      youtube[i].appendChild(image);
    }(i));

    youtube[i].addEventListener("click", function () {

      var iframe = document.createElement("iframe");

      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("allowfullscreen", "");
      iframe.setAttribute("src", "https://www.youtube.com/embed/" + this.dataset.embed + "?rel=0&showinfo=0&autoplay=1");

      this.innerHTML = "";
      this.appendChild(iframe);
    });
  };

})();

(function ($) {

  $('li').hover(
    function () { $(this).addClass("wpacc-hover"); },
    function () { $(this).delay('250').removeClass("wpacc-hover"); }
  );

  $('a').on('focus blur',
    function () { $(this).parents("li").toggleClass("wpacc-hover"); }
  );

}

  (jQuery)

);


$('.shutter-title').on('click',
  function () { $(this).toggleClass('active'); }
);
